import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const GiftWrapMessage = ({
  isLoading, message, isVisible, onChangeCallback, onMessageChange,
}) => {
  const onCheckboxChange = (evt) => {
    onChangeCallback(evt);
  };
  const onTextareaChange = (evt) => {
    onMessageChange(evt);
  };

  return (

    <div className={`cart-gift-wrap__message ${isVisible ? 'is-active' : ''}`}>
      <div className="embed-responsive">
        <textarea
          id="CartNote"
          name="note"
          placeholder="Max 250 characters"
          rows="10"
          className="embed-responsive-item"
          onChange={onTextareaChange}
          value={isVisible ? message : ''}
          maxLength="250"
        />
      </div>
      <label className="form-control custom-checkbox-wrapper" htmlFor="cart-notes-toggle">
        <input
          id="cart-notes-toggle"
          type="checkbox"
          defaultChecked={isVisible}
          disabled={isLoading}
          onChange={onCheckboxChange}
        />
        <div className="custom-checkbox__icon" />
        <span>Add a gift message</span>
      </label>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
});

const mapDispatchToProps = {
};

GiftWrapMessage.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  message: PropTypes.string,
  isVisible: PropTypes.bool,
  onChangeCallback: PropTypes.func.isRequired,
  onMessageChange: PropTypes.func.isRequired,
};

GiftWrapMessage.defaultProps = {
  message: '',
  isVisible: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftWrapMessage);
